import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import SurveyDetailPage from '@/pages/organizations/detail/surveys/detail'

export const Route = createFileRoute('/app/organizations/$organizationId/surveys/$surveyId')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <SurveyDetailPage />
}
